'use client';
import { ButtonProps } from '@mui/material';
import { FilledButtonWrapper } from './styles';

interface FilledIconButtonProps extends ButtonProps {
    readonly icon: React.ReactNode;
}

const FilledIconButton = ({ icon, ...buttonProps }: FilledIconButtonProps) => {
    return (
        <FilledButtonWrapper variant={'contained'} {...buttonProps}>
            {icon}
        </FilledButtonWrapper>
    );
};

export { FilledIconButton };
